export enum testStatus {
  "DEMOGRAPHIC",
  "PERSONALITY",
  "ITEMS_COLLECTION_LIKED",
  "ITEMS_COLLECTION_DISLIKED",
  "FEEDBACK",
  "COMPLETED",
  __length = 6
}